import React, { useState, useEffect, useContext } from 'react';
import SmallGigCardCarousel from '@fiverr-private/gig_listings/src/entries/SmallGigCardCarousel';
import { I18n } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { CollectionContext, AppContext } from '../../../../store';
import recentlyViewedService from '../../../../service/recentlyViewed';
import { RecentlyViewedTypes } from '../../../../types';
import './index.scss';

const RecentlyViewedCarousel = (props) => {
    const appContext = useContext(AppContext);
    const { user, showTranslatedUGC } = appContext;
    const { activeFilters, sorting } = props;
    const { loggedIn } = user;
    const { collectProps } = useContext(CollectionContext);

    const [listings, setListings] = useState(
        [{
            gigs: [],
            showTranslatedUGC
        }]
    );

    useEffect(() => {
        recentlyViewedService.fetch(sorting, activeFilters, appContext)
            .then((listings) => {
                setListings([{ ...listings }]);
            }).catch((err) => {
                logger.error({
                    message: 'Failed to fetch recently viewed gigs.',
                    error: err
                });
            });

    }, [ activeFilters, sorting, appContext ]);

    const showCarousel = listings[0].gigs.length > 0;
    const showSeeAll = loggedIn;
    const onCarouselItemClear = recentlyViewedService.clearRecentlyViewedGig(loggedIn);

    const clearGigs = () => {
        setListings([{ gigs: [] }]);

        recentlyViewedService.clearAllRecentlyViewedGigs(loggedIn);
    };

    return (
        showCarousel ?
            <div className="recently-viewed-carousel">
                <header>
                    <h2><I18n k="search_perseus.browsing_history_carousel.title"/></h2>
                    <span className="buttons-wrapper">
                        <button onClick={clearGigs}><I18n k="search_perseus.browsing_history_carousel.clear_all"/></button>
                        {showSeeAll &&
                            <React.Fragment>
                                <span className="separator">|</span>
                                <a href={recentlyViewedService.recentlyViewedPageURL()}><I18n k="search_perseus.browsing_history_carousel.see_all"/></a>
                            </React.Fragment>
                        }
                    </span>
                </header>
                <SmallGigCardCarousel onClearGig={onCarouselItemClear}
                    {...listings[0]}
                    collectProps={collectProps}
                    lazyLoad={true}/>
            </div> :
            null
    );
};

RecentlyViewedCarousel.propTypes = RecentlyViewedTypes;

export default RecentlyViewedCarousel;
